module.exports = __webpack_public_path__ + "static/media/logo-qubits-white.5d7af35f.png";